<div class="container-customer full-width">
    <div class="box-customer">
        <h5>Need a custom rate?</h5>
        <p>Request a quote, and our sales team will give you a personalized rate.</p>
        <up-button class="button-opacity" button-style="outlined" (click)="openExternalScreen()">REQUEST A QUOTE
        </up-button>
    </div><br>
</div>